import React, { useState, useEffect } from "react";
import {
  useFlowController,
  Icon,
  IconColorStyle,
  IconSize,
  setFlowDataDirect,
  FlowTypes,
  useFlowData,
  timeout,
  getFlowDataDirect,
  subscribeDataChange,
  unsubscribeDataChange,
} from "@adaptis/flow-components";
import { getPromocode } from "../../util/data-store";
import { validationPromo } from "../../util/knose-api-wrapper";
import LoadingLightbox from "../LoadingLightbox";
import { InputGroup, Form, FormControl, Button } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";
import { IApplyCouponProps } from "./ApplyCoupon.types";
import "./ApplyCoupon.scss";

export default function ApplyCoupon(props: IApplyCouponProps) {
  const { setData, getData } = useFlowData();
  const [showPromoCodeBox, setShowPromoCodeBox] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [isInvalid, setIsInvalid] = React.useState(false);
  const [loadingPrice, setLoadingPrice] = React.useState(false);
  const [showValidMessage, setshowValidMessage] = React.useState(false);
  const [inputClass, setInputClass] = React.useState("");
  const [promoCodeList, setPromoCodeList] = React.useState<
    Array<FlowTypes.IFlowPromotionCode>
  >([]);
  const currentPromoCode = getData("root.promoCode") ?? "";
  const pets = getData("root.pets") ?? undefined;
  const showComponent = true;
  // const showComponent = ((pets ? pets.length : 0) == 1 ? true : (currentPromoCode != "" ? false : true));
  let isInvalidPromotionCode = getData("root.isInvalidPromotionCode");
  let transferQuote = getFlowDataDirect("TransferQuoteCallBack") === "Yes";
  transferQuote = false;
  function showInput(e: any) {
    e.preventDefault();
    setShowPromoCodeBox(true);
  }

  async function onKeyUp(e: any) {
    if (e.key === "Enter") {
      await applyCoupon();
    }
    setshowValidMessage(false);
    if (!coupon) {
      setInputClass("");
      setIsInvalid(false);
    } else {
      setInputClass("has-value");
    }
  }

  async function applyCoupon() {
    try {
      setFlowDataDirect("isInvalidPromotionCode", false);
      setFlowDataDirect("isSavedQuote", false);
      setFlowDataDirect("isChangedData", false);
      setIsInvalid(false);
      setshowValidMessage(false);
      if (currentPromoCode === coupon.trim()) {
        setInputClass("has-value is-valid");
        setIsInvalid(false);
        return;
      }
      if (!coupon.trim()) {
        setInputClass("");
        setData("root.promoCode", "");
        return;
      }
      let checkingPromoCode = coupon.trim();
      setInputClass("has-value");
      setLoadingPrice(true);
      let selectedPromotionCode: FlowTypes.IFlowPromotionCode = {
        promoCode: "",
        promotionMessage: "",
        campaignName: "",
        type: 1,
        imgSrc: "",
        percent: 0,
        period: "",
      };
      let coporatesPromoCodes = getFlowDataDirect("CoporatesPromoCodes");
      let isCoporatesPromoCode = false;
      let isPetsyPerksforPals = false;
      let coporateDomain = "";
      if (checkingPromoCode.includes("@")) {
        coporateDomain = checkingPromoCode.split("@")[1];
      }
      if (coporatesPromoCodes && coporateDomain) {
        let coporatesPromoCodeFiltered = coporatesPromoCodes.find((item: any) => item.email === `@${coporateDomain}`);
        if (coporatesPromoCodeFiltered) {
          isCoporatesPromoCode = true;
          selectedPromotionCode = coporatesPromoCodeFiltered;
          checkingPromoCode = coporatesPromoCodeFiltered.promoCode;
          // setCoupon("");
        }
      }

      if (!isCoporatesPromoCode) {
        // Check for FNF followed by any number pattern
        const fnfPattern = /^(FNF[12]).+\d{3,3}$/;
        const match = checkingPromoCode.match(fnfPattern);
        if (match) {
          // Get the FNF type (FNF1 or FNF2)
          const fnfType = match[1]; // This will be FNF1 or FNF2
          // Transform to FNF1FREE or FNF2FREE
          checkingPromoCode = `${fnfType}FREE`;
          isPetsyPerksforPals = true;
          let filteredPromoCode: any = await getPromocode(checkingPromoCode);
          if (!filteredPromoCode) {
            setLoadingPrice(false);
            setIsInvalid(true);
            return;
          }

          selectedPromotionCode = {
            promoCode: checkingPromoCode,
            promotionMessage: filteredPromoCode.promotionMessage,
            campaignName: filteredPromoCode.campaignName,
            type: filteredPromoCode.type ? parseInt(filteredPromoCode.type.replace("Type", '')) : undefined,
            imgSrc: filteredPromoCode.imagePath,
            percent: filteredPromoCode.discount,
            period: filteredPromoCode.period,
            discount: filteredPromoCode.discount,
          }
        }
      }

      if (!isCoporatesPromoCode && !isPetsyPerksforPals) {
        let filteredPromoCode: any = await getPromocode(checkingPromoCode);
        if (!filteredPromoCode) {
          setLoadingPrice(false);
          setIsInvalid(true);
          return;
        }
        selectedPromotionCode = {
          promoCode: checkingPromoCode,
          promotionMessage: filteredPromoCode.promotionMessage,
          campaignName: filteredPromoCode.campaignName,
          type: filteredPromoCode.type ? parseInt(filteredPromoCode.type.replace("Type", '')) : undefined,
          imgSrc: filteredPromoCode.imagePath,
          percent: filteredPromoCode.discount,
          period: filteredPromoCode.period,
          discount: filteredPromoCode.discount,
        }
      }

      let validation: any = await validationPromo(checkingPromoCode);
      if (!validation || !validation.data) {
        setLoadingPrice(false);
        setIsInvalid(true);
        return;
      }
      setLoadingPrice(false);
      setIsInvalid(false);
      setData("root.selectedPromoCode", selectedPromotionCode);
      setData("root.promoCode", checkingPromoCode);
      setData("root.promoCodeType", selectedPromotionCode ? selectedPromotionCode.type : 1);
      setData("root.couponBannerHidden", false);
      setInputClass("has-value is-valid");
      setshowValidMessage(true);
    } catch (error: any) {
      console.log("Applying coupon error: ", error.message || "");
    }

  }

  useEffect(() => {
    if (!currentPromoCode) {
      setCoupon(currentPromoCode);
      if (!isInvalidPromotionCode) {
        setIsInvalid(false);
        setInputClass("");
      }
    }
  }, [currentPromoCode])

  useEffect(() => {
    if (isInvalidPromotionCode) {
      setIsInvalid(true);
      setInputClass("has-value");
      setData("root.promoCode", null);
      setData("root.promoCodeType", 1);
      setData("root.selectedPromoCode", null);
    }
  }, [isInvalidPromotionCode]);


  const animateProps = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.5 },
  };

  return (
    <>
      {props && !currentPromoCode && showComponent && !transferQuote && (
        <div data-testid="ApplyCoupon" className={"flc_apply-coupon " + (props.className ?? "")}>
          <AnimatePresence>
            <motion.div key="question-coupon-code" {...animateProps}>
              {!showPromoCodeBox && (
                <a href="" onClick={showInput}>
                  Do you have a promotion code?
                </a>
              )}
            </motion.div>
            {showPromoCodeBox && (
              <motion.div key="apply-coupon-code" {...animateProps}>
                <InputGroup>
                  <FormControl
                    className={inputClass}
                    placeholder=""
                    aria-label="Promotion code"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                    onKeyUp={onKeyUp}
                    autoFocus
                    isInvalid={isInvalid}
                    onLoad={(event) => event.currentTarget.blur()}
                  />
                  <label>Enter your promotion code</label>
                  <Button
                    className="apply-coupon-btn"
                    variant=""
                    onClick={(e) => {
                      e.preventDefault();
                      applyCoupon();
                    }}
                  >
                    Apply
                  </Button>
                  <Form.Control.Feedback type="invalid">
                    Oops, that didn't work. Please enter a valid code and try again.
                  </Form.Control.Feedback>
                  {showValidMessage && (
                    <div className="valid-feedback">Nice! You're good to go.</div>
                  )}
                </InputGroup>
              </motion.div>
            )}
          </AnimatePresence>
          <LoadingLightbox show={loadingPrice} title="Loading your Quote..." />
        </div>
      )}
    </>
  );
}
